import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.662 14.949c.148.903.452 2.306.937 3.327.765 1.581 9.908.267 8.471-2.128-1.905-3.174-6.462 2.2-.959 3.843"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m3.508 15.536 1.703-.117c.275-.02.48-.297.457-.63l-.286-4.162c-.023-.332-.266-.596-.54-.56l-1.752.138c-.241.017-.432.258-.447.54-.046.83-.067 2.536.332 4.318.072.294.292.49.533.473M20.434 14.196l-1.6.11c-.257.018-.482-.23-.505-.562l-.286-4.163c-.023-.332.164-.626.424-.626l1.636-.078c.223-.015.428.2.481.477.143.816.397 2.503.263 4.322.002.28-.19.505-.413.52"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4.998 10.074s.055-6.998 6.295-7.462c5.964-.445 6.774 6.81 6.774 6.81"
    />
  </svg>
);
export const SupportIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
